import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import Lottie from "lottie-react";
import warningAnimation from "../../../../assets/lottie/warning.json"; // ⚠️ Add a warning/alert animation
import {
  primaryButtonStyles,
  secondaryButtonStyles,
} from "../../../../Styles/Styles";

const SoldStatusPromptModal = ({ open, message, onConfirm, onCancel }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-confirmation-dialog"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Lottie
          animationData={warningAnimation}
          style={{ width: 120, height: 120 }}
          loop={true}
        />
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            fontFamily: "ClashGrotesk-Regular",
            textAlign: "center",
          }}
        >
          {message || "Are you sure you want to delete this item?"}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{ ...primaryButtonStyles }}
        >
          Yes, Confirm
        </Button>
        <Button
          onClick={onCancel}
          variant="contained"
          sx={{ ...secondaryButtonStyles }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SoldStatusPromptModal;
